const footerGlobal = {
  config: {
    general: {
      hintText:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean coms",
      secondaryLinks: {
        imprint: {
          url: "https://en.wikipedia.org/wiki/Texas_Revolution",
          label: "Impressum", // de/en
        },
        privacy: {
          url: "https://en.wikipedia.org/wiki/Casablanca_(film)",
          label: "Datenschutz", // de/en
        },
        cookieSettings: {
          url: "",
          label: "Cookie Einstellungen", // de/en
        },
      },
      textColor: {
        label: "Default Black",
        value: "#161616",
      },
      backgroundColor: {
        label: "White Smoke",
        value: "#f5f5f5",
      },
      socialIconsColor: {
        label: "Light Grey",
        value: "#DBDBDB",
      },
    },
  },
};

export default footerGlobal;
